import React from 'react';
import Modal from './Modal';
import { styles } from '../../styles/theme';

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirmar Acao',
  message = 'Tem certeza que deseja continuar?',
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  variant = 'danger' // 'danger' | 'warning' | 'primary'
}) => {
  const getConfirmButtonStyle = () => {
    switch (variant) {
      case 'danger':
        return { ...styles.button, backgroundColor: '#da3633' };
      case 'warning':
        return { ...styles.button, backgroundColor: '#f85149' };
      default:
        return styles.button;
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} maxWidth="400px">
      <div style={{ marginBottom: '24px' }}>
        <p style={{ color: '#c9d1d9', fontSize: '14px', margin: 0 }}>
          {message}
        </p>
      </div>
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
        <button
          style={{ ...styles.button, ...styles.buttonSecondary }}
          onClick={onClose}
        >
          {cancelText}
        </button>
        <button
          style={getConfirmButtonStyle()}
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          {confirmText}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
